import { render } from "./ContactSettingsPreview.vue?vue&type=template&id=728e2679&scoped=true"
import script from "./ContactSettingsPreview.vue?vue&type=script&lang=js"
export * from "./ContactSettingsPreview.vue?vue&type=script&lang=js"

import "./ContactSettingsPreview.vue?vue&type=style&index=0&id=728e2679&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728e2679"]])

export default __exports__